module.exports = __webpack_public_path__ + "static/media/yz_m2.5b0945c3.webp";